import React from 'react';
import {
  AutocompleteInput,
  Edit,
  ReferenceInput,
  SimpleForm,
} from 'react-admin';
import EditToolbar from './EditToolbar';
import { disableAutofillOptions } from '../../helper';
import ModalView from './ModalView';

const redirect = (basePath, id) => `/customer/${id}/show/redirect`;

const BusinessAddressEdit = ({ openEdit, setOpenEdit, ...props }) => (
  <ModalView openEdit={openEdit} setOpenEdit={setOpenEdit}>
    <Edit {...props} actions={null} undoable={false} title=" ">
      <SimpleForm
        redirect={redirect}
        toolbar={<EditToolbar setOpenEdit={setOpenEdit} />}
      >
        <ReferenceInput
          source="default_client_location_id"
          reference="client-location"
          allowEmpty
          perPage={200}
        >
          <AutocompleteInput
            optionText="long_name"
            options={disableAutofillOptions}
          />
        </ReferenceInput>
      </SimpleForm>
    </Edit>
  </ModalView>
);

export default BusinessAddressEdit;
